<script>
	import { Icon } from '@Shelly/shelly-design-system';
	import LogoutModal from './LogoutModal.svelte';

	let showModal = false;

	const handleLogoutClick = () => {
		showModal = true;
	};
</script>

<Icon class="cursor-pointer ml-m" icon="fat fa-right-from-bracket" on:click={handleLogoutClick} />

<LogoutModal bind:showModal />
